/* tslint:disable */
/* eslint-disable */
/**
 * Munchi Dashboard Server Api
 * The Munchi API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { GenerateReportResponseDto } from '../models';
// @ts-ignore
import type { ReportJobAcceptedDto } from '../models';
// @ts-ignore
import type { ReportJobStatusDto } from '../models';
// @ts-ignore
import type { RunReportJobDto } from '../models';
// @ts-ignore
import type { SendReportEmailDto } from '../models';
/**
 * ReportsApi - axios parameter creator
 * @export
 */
export const ReportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Enqueue an async sales report job
         * @param {EnqueueTimeSpanEnum} timeSpan 
         * @param {string} businessId Business ID
         * @param {string} timezone Timezone
         * @param {EnqueueLanguageEnum} language 
         * @param {EnqueueSourceEnum} source 
         * @param {string} [start] Start date (ISO 8601)
         * @param {string} [end] End date (ISO 8601)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enqueue: async (timeSpan: EnqueueTimeSpanEnum, businessId: string, timezone: string, language: EnqueueLanguageEnum, source: EnqueueSourceEnum, start?: string, end?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'timeSpan' is not null or undefined
            assertParamExists('enqueue', 'timeSpan', timeSpan)
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('enqueue', 'businessId', businessId)
            // verify required parameter 'timezone' is not null or undefined
            assertParamExists('enqueue', 'timezone', timezone)
            // verify required parameter 'language' is not null or undefined
            assertParamExists('enqueue', 'language', language)
            // verify required parameter 'source' is not null or undefined
            assertParamExists('enqueue', 'source', source)
            const localVarPath = `/api/v2/reports/jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (timeSpan !== undefined) {
                localVarQueryParameter['timeSpan'] = timeSpan;
            }

            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = end;
            }

            if (businessId !== undefined) {
                localVarQueryParameter['businessId'] = businessId;
            }

            if (timezone !== undefined) {
                localVarQueryParameter['timezone'] = timezone;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate unified sales breakdown report by source
         * @param {GenerateTimeSpanEnum} timeSpan 
         * @param {string} businessId Business ID
         * @param {string} timezone Timezone
         * @param {GenerateLanguageEnum} language 
         * @param {GenerateSourceEnum} source 
         * @param {string} [start] Start date (ISO 8601)
         * @param {string} [end] End date (ISO 8601)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generate: async (timeSpan: GenerateTimeSpanEnum, businessId: string, timezone: string, language: GenerateLanguageEnum, source: GenerateSourceEnum, start?: string, end?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'timeSpan' is not null or undefined
            assertParamExists('generate', 'timeSpan', timeSpan)
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('generate', 'businessId', businessId)
            // verify required parameter 'timezone' is not null or undefined
            assertParamExists('generate', 'timezone', timezone)
            // verify required parameter 'language' is not null or undefined
            assertParamExists('generate', 'language', language)
            // verify required parameter 'source' is not null or undefined
            assertParamExists('generate', 'source', source)
            const localVarPath = `/api/v2/reports/sales-breakdown`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (timeSpan !== undefined) {
                localVarQueryParameter['timeSpan'] = timeSpan;
            }

            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = end;
            }

            if (businessId !== undefined) {
                localVarQueryParameter['businessId'] = businessId;
            }

            if (timezone !== undefined) {
                localVarQueryParameter['timezone'] = timezone;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate Online Sales Breakdown Report
         * @param {GenerateOnlineReportTimeSpanEnum} timeSpan 
         * @param {string} businessId Business ID
         * @param {string} timezone Timezone
         * @param {GenerateOnlineReportLanguageEnum} language 
         * @param {string} [start] Start date (ISO 8601)
         * @param {string} [end] End date (ISO 8601)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateOnlineReport: async (timeSpan: GenerateOnlineReportTimeSpanEnum, businessId: string, timezone: string, language: GenerateOnlineReportLanguageEnum, start?: string, end?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'timeSpan' is not null or undefined
            assertParamExists('generateOnlineReport', 'timeSpan', timeSpan)
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('generateOnlineReport', 'businessId', businessId)
            // verify required parameter 'timezone' is not null or undefined
            assertParamExists('generateOnlineReport', 'timezone', timezone)
            // verify required parameter 'language' is not null or undefined
            assertParamExists('generateOnlineReport', 'language', language)
            const localVarPath = `/api/v1/reports/online-sales-breakdown`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (timeSpan !== undefined) {
                localVarQueryParameter['timeSpan'] = timeSpan;
            }

            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = end;
            }

            if (businessId !== undefined) {
                localVarQueryParameter['businessId'] = businessId;
            }

            if (timezone !== undefined) {
                localVarQueryParameter['timezone'] = timezone;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate Sales Breakdown Report
         * @param {GenerateReportTimeSpanEnum} timeSpan 
         * @param {string} businessId Business ID
         * @param {string} timezone Timezone
         * @param {GenerateReportLanguageEnum} language 
         * @param {string} [start] Start date (ISO 8601)
         * @param {string} [end] End date (ISO 8601)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateReport: async (timeSpan: GenerateReportTimeSpanEnum, businessId: string, timezone: string, language: GenerateReportLanguageEnum, start?: string, end?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'timeSpan' is not null or undefined
            assertParamExists('generateReport', 'timeSpan', timeSpan)
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('generateReport', 'businessId', businessId)
            // verify required parameter 'timezone' is not null or undefined
            assertParamExists('generateReport', 'timezone', timezone)
            // verify required parameter 'language' is not null or undefined
            assertParamExists('generateReport', 'language', language)
            const localVarPath = `/api/v1/reports/sales-breakdown`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (timeSpan !== undefined) {
                localVarQueryParameter['timeSpan'] = timeSpan;
            }

            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = end;
            }

            if (businessId !== undefined) {
                localVarQueryParameter['businessId'] = businessId;
            }

            if (timezone !== undefined) {
                localVarQueryParameter['timezone'] = timezone;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the status and result of a report job
         * @param {string} jobId 
         * @param {string} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatus: async (jobId: string, businessId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('getStatus', 'jobId', jobId)
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('getStatus', 'businessId', businessId)
            const localVarPath = `/api/v2/reports/jobs/{jobId}`
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (businessId !== undefined) {
                localVarQueryParameter['businessId'] = businessId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Run a queued report job (internal worker)
         * @param {RunReportJobDto} runReportJobDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        run: async (runReportJobDto: RunReportJobDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runReportJobDto' is not null or undefined
            assertParamExists('run', 'runReportJobDto', runReportJobDto)
            const localVarPath = `/api/v2/reports/jobs/run`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(runReportJobDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send Sales Breakdown Report via Email
         * @param {SendReportEmailTimeSpanEnum} timeSpan 
         * @param {string} businessId Business ID
         * @param {string} timezone Timezone
         * @param {SendReportEmailLanguageEnum} language 
         * @param {SendReportEmailDto} sendReportEmailDto 
         * @param {string} [start] Start date (ISO 8601)
         * @param {string} [end] End date (ISO 8601)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendReportEmail: async (timeSpan: SendReportEmailTimeSpanEnum, businessId: string, timezone: string, language: SendReportEmailLanguageEnum, sendReportEmailDto: SendReportEmailDto, start?: string, end?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'timeSpan' is not null or undefined
            assertParamExists('sendReportEmail', 'timeSpan', timeSpan)
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('sendReportEmail', 'businessId', businessId)
            // verify required parameter 'timezone' is not null or undefined
            assertParamExists('sendReportEmail', 'timezone', timezone)
            // verify required parameter 'language' is not null or undefined
            assertParamExists('sendReportEmail', 'language', language)
            // verify required parameter 'sendReportEmailDto' is not null or undefined
            assertParamExists('sendReportEmail', 'sendReportEmailDto', sendReportEmailDto)
            const localVarPath = `/api/v1/reports/sales-breakdown/email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (timeSpan !== undefined) {
                localVarQueryParameter['timeSpan'] = timeSpan;
            }

            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = end;
            }

            if (businessId !== undefined) {
                localVarQueryParameter['businessId'] = businessId;
            }

            if (timezone !== undefined) {
                localVarQueryParameter['timezone'] = timezone;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendReportEmailDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportsApi - functional programming interface
 * @export
 */
export const ReportsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Enqueue an async sales report job
         * @param {EnqueueTimeSpanEnum} timeSpan 
         * @param {string} businessId Business ID
         * @param {string} timezone Timezone
         * @param {EnqueueLanguageEnum} language 
         * @param {EnqueueSourceEnum} source 
         * @param {string} [start] Start date (ISO 8601)
         * @param {string} [end] End date (ISO 8601)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enqueue(timeSpan: EnqueueTimeSpanEnum, businessId: string, timezone: string, language: EnqueueLanguageEnum, source: EnqueueSourceEnum, start?: string, end?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportJobAcceptedDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enqueue(timeSpan, businessId, timezone, language, source, start, end, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.enqueue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Generate unified sales breakdown report by source
         * @param {GenerateTimeSpanEnum} timeSpan 
         * @param {string} businessId Business ID
         * @param {string} timezone Timezone
         * @param {GenerateLanguageEnum} language 
         * @param {GenerateSourceEnum} source 
         * @param {string} [start] Start date (ISO 8601)
         * @param {string} [end] End date (ISO 8601)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generate(timeSpan: GenerateTimeSpanEnum, businessId: string, timezone: string, language: GenerateLanguageEnum, source: GenerateSourceEnum, start?: string, end?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateReportResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generate(timeSpan, businessId, timezone, language, source, start, end, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.generate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Generate Online Sales Breakdown Report
         * @param {GenerateOnlineReportTimeSpanEnum} timeSpan 
         * @param {string} businessId Business ID
         * @param {string} timezone Timezone
         * @param {GenerateOnlineReportLanguageEnum} language 
         * @param {string} [start] Start date (ISO 8601)
         * @param {string} [end] End date (ISO 8601)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateOnlineReport(timeSpan: GenerateOnlineReportTimeSpanEnum, businessId: string, timezone: string, language: GenerateOnlineReportLanguageEnum, start?: string, end?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateReportResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateOnlineReport(timeSpan, businessId, timezone, language, start, end, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.generateOnlineReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Generate Sales Breakdown Report
         * @param {GenerateReportTimeSpanEnum} timeSpan 
         * @param {string} businessId Business ID
         * @param {string} timezone Timezone
         * @param {GenerateReportLanguageEnum} language 
         * @param {string} [start] Start date (ISO 8601)
         * @param {string} [end] End date (ISO 8601)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateReport(timeSpan: GenerateReportTimeSpanEnum, businessId: string, timezone: string, language: GenerateReportLanguageEnum, start?: string, end?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateReportResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateReport(timeSpan, businessId, timezone, language, start, end, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.generateReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the status and result of a report job
         * @param {string} jobId 
         * @param {string} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStatus(jobId: string, businessId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportJobStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStatus(jobId, businessId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.getStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Run a queued report job (internal worker)
         * @param {RunReportJobDto} runReportJobDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async run(runReportJobDto: RunReportJobDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.run(runReportJobDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.run']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send Sales Breakdown Report via Email
         * @param {SendReportEmailTimeSpanEnum} timeSpan 
         * @param {string} businessId Business ID
         * @param {string} timezone Timezone
         * @param {SendReportEmailLanguageEnum} language 
         * @param {SendReportEmailDto} sendReportEmailDto 
         * @param {string} [start] Start date (ISO 8601)
         * @param {string} [end] End date (ISO 8601)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendReportEmail(timeSpan: SendReportEmailTimeSpanEnum, businessId: string, timezone: string, language: SendReportEmailLanguageEnum, sendReportEmailDto: SendReportEmailDto, start?: string, end?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendReportEmail(timeSpan, businessId, timezone, language, sendReportEmailDto, start, end, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.sendReportEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReportsApi - factory interface
 * @export
 */
export const ReportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportsApiFp(configuration)
    return {
        /**
         * 
         * @summary Enqueue an async sales report job
         * @param {EnqueueTimeSpanEnum} timeSpan 
         * @param {string} businessId Business ID
         * @param {string} timezone Timezone
         * @param {EnqueueLanguageEnum} language 
         * @param {EnqueueSourceEnum} source 
         * @param {string} [start] Start date (ISO 8601)
         * @param {string} [end] End date (ISO 8601)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enqueue(timeSpan: EnqueueTimeSpanEnum, businessId: string, timezone: string, language: EnqueueLanguageEnum, source: EnqueueSourceEnum, start?: string, end?: string, options?: RawAxiosRequestConfig): AxiosPromise<ReportJobAcceptedDto> {
            return localVarFp.enqueue(timeSpan, businessId, timezone, language, source, start, end, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate unified sales breakdown report by source
         * @param {GenerateTimeSpanEnum} timeSpan 
         * @param {string} businessId Business ID
         * @param {string} timezone Timezone
         * @param {GenerateLanguageEnum} language 
         * @param {GenerateSourceEnum} source 
         * @param {string} [start] Start date (ISO 8601)
         * @param {string} [end] End date (ISO 8601)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generate(timeSpan: GenerateTimeSpanEnum, businessId: string, timezone: string, language: GenerateLanguageEnum, source: GenerateSourceEnum, start?: string, end?: string, options?: RawAxiosRequestConfig): AxiosPromise<GenerateReportResponseDto> {
            return localVarFp.generate(timeSpan, businessId, timezone, language, source, start, end, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate Online Sales Breakdown Report
         * @param {GenerateOnlineReportTimeSpanEnum} timeSpan 
         * @param {string} businessId Business ID
         * @param {string} timezone Timezone
         * @param {GenerateOnlineReportLanguageEnum} language 
         * @param {string} [start] Start date (ISO 8601)
         * @param {string} [end] End date (ISO 8601)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateOnlineReport(timeSpan: GenerateOnlineReportTimeSpanEnum, businessId: string, timezone: string, language: GenerateOnlineReportLanguageEnum, start?: string, end?: string, options?: RawAxiosRequestConfig): AxiosPromise<GenerateReportResponseDto> {
            return localVarFp.generateOnlineReport(timeSpan, businessId, timezone, language, start, end, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate Sales Breakdown Report
         * @param {GenerateReportTimeSpanEnum} timeSpan 
         * @param {string} businessId Business ID
         * @param {string} timezone Timezone
         * @param {GenerateReportLanguageEnum} language 
         * @param {string} [start] Start date (ISO 8601)
         * @param {string} [end] End date (ISO 8601)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateReport(timeSpan: GenerateReportTimeSpanEnum, businessId: string, timezone: string, language: GenerateReportLanguageEnum, start?: string, end?: string, options?: RawAxiosRequestConfig): AxiosPromise<GenerateReportResponseDto> {
            return localVarFp.generateReport(timeSpan, businessId, timezone, language, start, end, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the status and result of a report job
         * @param {string} jobId 
         * @param {string} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatus(jobId: string, businessId: string, options?: RawAxiosRequestConfig): AxiosPromise<ReportJobStatusDto> {
            return localVarFp.getStatus(jobId, businessId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Run a queued report job (internal worker)
         * @param {RunReportJobDto} runReportJobDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        run(runReportJobDto: RunReportJobDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.run(runReportJobDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send Sales Breakdown Report via Email
         * @param {SendReportEmailTimeSpanEnum} timeSpan 
         * @param {string} businessId Business ID
         * @param {string} timezone Timezone
         * @param {SendReportEmailLanguageEnum} language 
         * @param {SendReportEmailDto} sendReportEmailDto 
         * @param {string} [start] Start date (ISO 8601)
         * @param {string} [end] End date (ISO 8601)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendReportEmail(timeSpan: SendReportEmailTimeSpanEnum, businessId: string, timezone: string, language: SendReportEmailLanguageEnum, sendReportEmailDto: SendReportEmailDto, start?: string, end?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendReportEmail(timeSpan, businessId, timezone, language, sendReportEmailDto, start, end, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportsApi - object-oriented interface
 * @export
 * @class ReportsApi
 * @extends {BaseAPI}
 */
export class ReportsApi extends BaseAPI {
    /**
     * 
     * @summary Enqueue an async sales report job
     * @param {EnqueueTimeSpanEnum} timeSpan 
     * @param {string} businessId Business ID
     * @param {string} timezone Timezone
     * @param {EnqueueLanguageEnum} language 
     * @param {EnqueueSourceEnum} source 
     * @param {string} [start] Start date (ISO 8601)
     * @param {string} [end] End date (ISO 8601)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public enqueue(timeSpan: EnqueueTimeSpanEnum, businessId: string, timezone: string, language: EnqueueLanguageEnum, source: EnqueueSourceEnum, start?: string, end?: string, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).enqueue(timeSpan, businessId, timezone, language, source, start, end, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate unified sales breakdown report by source
     * @param {GenerateTimeSpanEnum} timeSpan 
     * @param {string} businessId Business ID
     * @param {string} timezone Timezone
     * @param {GenerateLanguageEnum} language 
     * @param {GenerateSourceEnum} source 
     * @param {string} [start] Start date (ISO 8601)
     * @param {string} [end] End date (ISO 8601)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public generate(timeSpan: GenerateTimeSpanEnum, businessId: string, timezone: string, language: GenerateLanguageEnum, source: GenerateSourceEnum, start?: string, end?: string, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).generate(timeSpan, businessId, timezone, language, source, start, end, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate Online Sales Breakdown Report
     * @param {GenerateOnlineReportTimeSpanEnum} timeSpan 
     * @param {string} businessId Business ID
     * @param {string} timezone Timezone
     * @param {GenerateOnlineReportLanguageEnum} language 
     * @param {string} [start] Start date (ISO 8601)
     * @param {string} [end] End date (ISO 8601)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public generateOnlineReport(timeSpan: GenerateOnlineReportTimeSpanEnum, businessId: string, timezone: string, language: GenerateOnlineReportLanguageEnum, start?: string, end?: string, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).generateOnlineReport(timeSpan, businessId, timezone, language, start, end, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate Sales Breakdown Report
     * @param {GenerateReportTimeSpanEnum} timeSpan 
     * @param {string} businessId Business ID
     * @param {string} timezone Timezone
     * @param {GenerateReportLanguageEnum} language 
     * @param {string} [start] Start date (ISO 8601)
     * @param {string} [end] End date (ISO 8601)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public generateReport(timeSpan: GenerateReportTimeSpanEnum, businessId: string, timezone: string, language: GenerateReportLanguageEnum, start?: string, end?: string, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).generateReport(timeSpan, businessId, timezone, language, start, end, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the status and result of a report job
     * @param {string} jobId 
     * @param {string} businessId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public getStatus(jobId: string, businessId: string, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).getStatus(jobId, businessId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Run a queued report job (internal worker)
     * @param {RunReportJobDto} runReportJobDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public run(runReportJobDto: RunReportJobDto, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).run(runReportJobDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send Sales Breakdown Report via Email
     * @param {SendReportEmailTimeSpanEnum} timeSpan 
     * @param {string} businessId Business ID
     * @param {string} timezone Timezone
     * @param {SendReportEmailLanguageEnum} language 
     * @param {SendReportEmailDto} sendReportEmailDto 
     * @param {string} [start] Start date (ISO 8601)
     * @param {string} [end] End date (ISO 8601)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public sendReportEmail(timeSpan: SendReportEmailTimeSpanEnum, businessId: string, timezone: string, language: SendReportEmailLanguageEnum, sendReportEmailDto: SendReportEmailDto, start?: string, end?: string, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).sendReportEmail(timeSpan, businessId, timezone, language, sendReportEmailDto, start, end, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const EnqueueTimeSpanEnum = {
    day: 'day',
    week: 'week',
    month: 'month',
    custom: 'custom',
    year: 'year'
} as const;
export type EnqueueTimeSpanEnum = typeof EnqueueTimeSpanEnum[keyof typeof EnqueueTimeSpanEnum];
/**
 * @export
 */
export const EnqueueLanguageEnum = {
    fi: 'fi',
    en: 'en'
} as const;
export type EnqueueLanguageEnum = typeof EnqueueLanguageEnum[keyof typeof EnqueueLanguageEnum];
/**
 * @export
 */
export const EnqueueSourceEnum = {
    pos: 'pos',
    kiosk: 'kiosk',
    storefront: 'storefront',
    mobile: 'mobile'
} as const;
export type EnqueueSourceEnum = typeof EnqueueSourceEnum[keyof typeof EnqueueSourceEnum];
/**
 * @export
 */
export const GenerateTimeSpanEnum = {
    day: 'day',
    week: 'week',
    month: 'month',
    custom: 'custom',
    year: 'year'
} as const;
export type GenerateTimeSpanEnum = typeof GenerateTimeSpanEnum[keyof typeof GenerateTimeSpanEnum];
/**
 * @export
 */
export const GenerateLanguageEnum = {
    fi: 'fi',
    en: 'en'
} as const;
export type GenerateLanguageEnum = typeof GenerateLanguageEnum[keyof typeof GenerateLanguageEnum];
/**
 * @export
 */
export const GenerateSourceEnum = {
    pos: 'pos',
    kiosk: 'kiosk',
    storefront: 'storefront',
    mobile: 'mobile'
} as const;
export type GenerateSourceEnum = typeof GenerateSourceEnum[keyof typeof GenerateSourceEnum];
/**
 * @export
 */
export const GenerateOnlineReportTimeSpanEnum = {
    day: 'day',
    week: 'week',
    month: 'month',
    custom: 'custom',
    year: 'year'
} as const;
export type GenerateOnlineReportTimeSpanEnum = typeof GenerateOnlineReportTimeSpanEnum[keyof typeof GenerateOnlineReportTimeSpanEnum];
/**
 * @export
 */
export const GenerateOnlineReportLanguageEnum = {
    fi: 'fi',
    en: 'en'
} as const;
export type GenerateOnlineReportLanguageEnum = typeof GenerateOnlineReportLanguageEnum[keyof typeof GenerateOnlineReportLanguageEnum];
/**
 * @export
 */
export const GenerateReportTimeSpanEnum = {
    day: 'day',
    week: 'week',
    month: 'month',
    custom: 'custom',
    year: 'year'
} as const;
export type GenerateReportTimeSpanEnum = typeof GenerateReportTimeSpanEnum[keyof typeof GenerateReportTimeSpanEnum];
/**
 * @export
 */
export const GenerateReportLanguageEnum = {
    fi: 'fi',
    en: 'en'
} as const;
export type GenerateReportLanguageEnum = typeof GenerateReportLanguageEnum[keyof typeof GenerateReportLanguageEnum];
/**
 * @export
 */
export const SendReportEmailTimeSpanEnum = {
    day: 'day',
    week: 'week',
    month: 'month',
    custom: 'custom',
    year: 'year'
} as const;
export type SendReportEmailTimeSpanEnum = typeof SendReportEmailTimeSpanEnum[keyof typeof SendReportEmailTimeSpanEnum];
/**
 * @export
 */
export const SendReportEmailLanguageEnum = {
    fi: 'fi',
    en: 'en'
} as const;
export type SendReportEmailLanguageEnum = typeof SendReportEmailLanguageEnum[keyof typeof SendReportEmailLanguageEnum];
